import React, { useState, useEffect } from "react";

function Blog() {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBlogPosts = async () => {
    try {
      setError(null);

      // Önce build sırasında oluşturulan statik blog.json'u dene,
      // olmazsa rss2json'a düş.
      let data = null;
      try {
        const staticRes = await fetch(`${process.env.PUBLIC_URL}/blog.json`);
        if (staticRes.ok) {
          const json = await staticRes.json();
          if (json.items && json.items.length > 0) data = json;
        }
      } catch (e) {
        console.warn("blog.json okunamadı:", e);
      }

      if (!data) {
        const rssUrl = process.env.REACT_APP_MEDIUM_RSS_URL;
        if (!rssUrl) {
          throw new Error("Medium RSS URL environment variable tanımlanmamış");
        }
        const response = await fetch(rssUrl, {
          headers: { Accept: "application/json" },
        });
        if (!response.ok) {
          throw new Error(
            `HTTP Error: ${response.status} ${response.statusText}`,
          );
        }
        data = await response.json();
      }
      console.log("RSS API Response:", data);

      if (data.status === "ok" && data.items && data.items.length > 0) {
        const posts = data.items.map((item) => {
          // Görsel URL'ini description'dan çıkar
          const imgMatch = item.description.match(/<img[^>]+src="([^">]+)"/);
          const thumbnail = imgMatch ? imgMatch[1] : null;

          return {
            title: item.title,
            url: item.link,
            thumbnail: thumbnail,
            description:
              item.description.replace(/<[^>]*>/g, "").substring(0, 150) +
              "...",
            pubDate: new Date(item.pubDate).toLocaleDateString("tr-TR", {
              year: "numeric",
              month: "long",
              day: "numeric",
            }),
          };
        });
        setBlogPosts(posts);
        console.log("Blog posts loaded:", posts.length);
      } else {
        throw new Error(data.message || "RSS feed'den veri alınamadı");
      }
    } catch (error) {
      console.error("Error fetching blog posts:", error);
      setError(error.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchBlogPosts();
  }, []);

  return (
    <section
      id="blog"
      className="py-16 mb-10 bg-white dark:bg-black text-gray-600 dark:text-gray-300 px-10 p-10 rounded-xl mt-10 transition-colors duration-300"
    >
      <h2 className="text-4xl text-center mb-8 text-gray-700 dark:text-gray-200">
        Blog Posts
      </h2>
      <hr className="h-px my-8 bg-gray-400 dark:bg-gray-500 border-0" />

      {loading ? (
        <div className="flex justify-center items-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
          <span className="ml-4 text-gray-600 dark:text-gray-300">
            Loading blog posts...
          </span>
        </div>
      ) : error ? (
        <div className="text-center py-12">
          <div className="bg-red-50 dark:bg-red-900 border border-red-200 dark:border-red-700 rounded-lg p-6 mb-6">
            <h3 className="text-lg font-semibold text-red-800 dark:text-red-200 mb-2">
              Failed to Load Blog Posts
            </h3>
            <p className="text-red-600 dark:text-red-300 mb-4">{error}</p>
            <button
              onClick={() => {
                setLoading(true);
                setError(null);
                fetchBlogPosts();
              }}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
            >
              Try Again
            </button>
          </div>
        </div>
      ) : blogPosts.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-600 dark:text-gray-400 mb-4">
            No blog posts found yet.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {blogPosts.map((post, index) => (
            <a
              key={index}
              href={post.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col md:flex-row gap-6 p-6 bg-gray-50 dark:bg-[#111112] rounded-lg transition-transform hover:scale-[1.02] hover:shadow-lg"
            >
              {post.thumbnail && (
                <div className="md:w-1/3 flex-shrink-0">
                  <img
                    src={post.thumbnail}
                    alt={post.title}
                    className="w-full h-48 md:h-full object-cover rounded-lg"
                  />
                </div>
              )}
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-200 mb-2">
                  {post.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 mb-4">
                  {post.description}
                </p>
                <div className="text-purple-600 dark:text-purple-400 hover:underline">
                  Read More →
                </div>
              </div>
            </a>
          ))}
        </div>
      )}

      <div className="text-center mt-10">
        <a
          href="https://medium.com/@oznur.dev"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-full text-sm sm:text-lg px-6 sm:px-10 py-2.5 transition-all duration-300"
        >
          View All Posts on Medium
        </a>
      </div>
    </section>
  );
}

export default Blog;
